import formatDate from "@DateTime/functions/formatDate";
import usePassengers from "@Hooks/selector/usePassengers";
import useGetGbtSupportedLocale from "@Features/getByTransfer/hooks/useGetGbtSupportedLocale";
import {startOfTomorrow} from "date-fns"

export default function useCreateGetByTransferRedirectLink() {
    const locale = useGetGbtSupportedLocale()
    const link = "https://getbytransfer.com/"

    const {
        passengers = 1,
    } = usePassengers()

    const travelDate = formatDate(startOfTomorrow(), 'dd-MM-yyyy')

    // const transferLink = encodeURI(`https://getbytransfer.com/en/booking/?from=${fromName}&to=${toName}&persons=${passengers}&travelDate=${travelDate}`)
    const transferLink = encodeURI(`${link}/${locale}/${travelDate}/${passengers}`)

    return {
        transferLink,
    }
}